"use client";

import { FC } from "react";
import { SwiperSlide } from "swiper/react";
import Carousel from "apps/website/components/feature/Carousel/Carousel";
import Column from "apps/website/components/layout/Column/Column";

import TastyMonialsCarouselItem, {
  ITastyMonialsCarouselItem,
} from "./components/TastyMonialsCarouselItem/TastMonialsCarouselItem";

export interface ITastyMonialsCarousel {
  items: ITastyMonialsCarouselItem[];
}

const TastyMonialsCarousel: FC<ITastyMonialsCarousel> = ({ items }) => (
  <Column component="TastyMonialsCarousel" >
    <Carousel
      showNavigation={false}
      breakpoints={{
        default: 1.2,
        lg: 4,
      }}
    >
      { items.map((item, index) => (
        <SwiperSlide key={index}>
          <TastyMonialsCarouselItem {...item} />
        </SwiperSlide>
      )) }
    </Carousel>
  </Column>
);

export default TastyMonialsCarousel;
